import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/donation-setup/item-categories";

export const Route = createFileRoute("/admin/_donation-setup/item-categories")({
  component: Page,
});
